<template>
    <div :class="['card shadow text-center', marginBottom]" ref="card">
        <div class="card-content p-3">
            <slot name="icon">
                <font-awesome-icon :icon="icon" size="4x" class="mt-3 primary" v-if="!!icon && awesomeicon"></font-awesome-icon>
                <img :src="icon" class="mt-3 primary" v-if="!!icon && !awesomeicon" />
            </slot>
            <slot name="title">
                <h2 class="mt-3 mb-3 title" v-if="!!title"><span v-html="title"></span></h2>
            </slot>
            <slot name="content">
                <p class="text-muted" v-if="!!description"><span v-html="description"></span></p>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'card',
    props: {
        title: {
            type: String
        },
        description: {
            type: String
        },
        icon: {
            type: String
        },
        awesomeicon: {
            type: Boolean,
            default: false
        },
        marginBottom: {
            type: String,
            default: 'mb-5'
        }
    },
    mounted(ev, a) {
        setTimeout(() => {
            this.$refs.card.classList.add('visible');
        }, 1);
    }
}
</script>

<style scoped>
    .card {
        border-radius: 0;
        opacity: 0;
        margin-top: 50px;
        transition: opacity .5s ease-in-out, margin-top 1s;
        -moz-transition: opacity .5s ease-in-out, margin-top 1s;
        -webkit-transition: opacity .5s ease-in-out, margin-top 1s;
    }
    .card.visible {
        opacity: 1;
        margin-top: 0px;
    }
    img {
        max-width: 80%;
        max-height: 45px;
    }
    .title {
        font-size: 1.5rem;
        font-weight: 700;
        text-transform: uppercase;
    }
    .title .red {
        color: #DD0426;
    }
</style>